// src/modules/purityAnalyzer/components/hud/MetalComposition.jsx
// XRF-report style composition table: element, emission line, concentration
// and a proportional bar. Only the Au / other-metal split is measured — the
// alloying-metal breakdown is an indicative jeweller's-alloy model (·EST).

import React from 'react';
import { motion } from 'framer-motion';
import { buildComposition } from './XrfSpectrum';

const cell = { padding: '7px 8px', whiteSpace: 'nowrap' };
const rowBorder = { borderBottom: '1px solid rgba(0,229,255,0.10)' };

export default function MetalComposition({ purity = 0, otherMetalPercent }) {
  const composition = buildComposition(purity, otherMetalPercent);
  const maxPercent = Math.max(...composition.map((c) => c.percent), 1);

  return (
    <div>
      <table style={{ width: '100%', borderCollapse: 'collapse' }}>
        <thead>
          <tr style={rowBorder}>
            {['ELEMENT', 'LINE', 'CONC.', ''].map((h, i) => (
              <th key={h || 'bar'} className="pa-label"
                style={{ ...cell, textAlign: i === 2 ? 'right' : 'left', fontWeight: 400 }}>
                {h}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {composition.map((el, i) => (
            <motion.tr key={el.symbol} style={rowBorder}
              initial={{ opacity: 0 }} animate={{ opacity: 1 }}
              transition={{ delay: 0.15 + i * 0.1 }}>
              <td style={cell}>
                <span className="pa-mono" style={{ color: el.color, fontWeight: 700, fontSize: 13, marginRight: 8 }}>
                  {el.symbol}
                </span>
                <span className="pa-label">
                  {el.name}
                  {!el.measured && <span style={{ opacity: 0.55 }}> ·EST</span>}
                </span>
              </td>
              <td className="pa-label" style={cell}>{el.line}</td>
              <td className="pa-value pa-mono" style={{ ...cell, textAlign: 'right', fontSize: 13, color: el.color }}>
                {el.percent.toFixed(2)}%
              </td>
              <td style={{ ...cell, width: '32%' }}>
                <div style={{ height: 6, borderRadius: 3, background: 'rgba(255,255,255,0.06)' }}>
                  <motion.div
                    initial={{ width: 0 }}
                    animate={{ width: `${(el.percent / maxPercent) * 100}%` }}
                    transition={{ duration: 0.8, delay: 0.3 + i * 0.1, ease: 'easeOut' }}
                    style={{ height: '100%', borderRadius: 3, background: el.color, opacity: 0.85 }}
                  />
                </div>
              </td>
            </motion.tr>
          ))}
        </tbody>
      </table>
      <div className="pa-label" style={{ marginTop: 10, opacity: 0.6 }}>
        Au measured by density · alloy split is an indicative model — confirm by XRF.
      </div>
    </div>
  );
}
